export const reconfirmDeceasedModalContent = (patientName: string) => {
    return (
        <>
            <p style={{marginBottom: '16px'}}>Normally a visit for a deceased patient has burial consent or euthanasia forms. We don't see any of those here.</p>
            <p>Are you sure you want to mark <strong>{patientName}</strong> as deceased?</p>
        </>
    );
};
